<svg xmlns="http://www.w3.org/2000/svg" class="icon icon--loader" [ngClass]="size()==='small' ? 'icon--loader-small' : ''" viewBox="0 0 100 100">
  <circle cx="50" cy="50" fill="none" stroke="currentcolor" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
  </circle>
</svg>